import { render, staticRenderFns } from "./VisitReasonTable.vue?vue&type=template&id=17d83f30&scoped=true&"
import script from "./VisitReasonTable.vue?vue&type=script&lang=js&"
export * from "./VisitReasonTable.vue?vue&type=script&lang=js&"
import style0 from "./VisitReasonTable.vue?vue&type=style&index=0&id=17d83f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d83f30",
  null
  
)

export default component.exports